// Completed By Rabbil Hasan
// 14-05-2014 5:43AM
import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import RefundDescription from "../../Components/RefundDescription/RefundDescription";
import Footer from "../../Components/Common/Footer";

class RefundPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }
  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <RefundDescription />
        </div>
        <Footer />
      </Fragment>
    );
  }
}
export default RefundPage;
